import React, { useEffect, useState } from 'react';

import { Cookies, CookieService } from '../../core/services/cookieService';
import { EmbedService, Messages } from '../../core/services/embedService';
import { LoadingSpinner } from '../RedirectChecker/RedirectChecker';
import Title from '../Title/Title';
import GetMobileApp from '../AdditionalInfo/GetMobileApp';
import AuthButton from '../AuthButton/AuthButton';

import '../CompletedForms/CompletedForms.scss';
import { getSsoRoute } from '../../utilities/getSsoRoute';
import { getRedirectTo } from '../../utilities/getRedirectTo';

const AccountCreated = ({
  embedService = EmbedService.Instance(),
  cookieService = CookieService.Instance()
}) => {
  const [accessToken, setAccessToken] = useState('');

  useEffect(() => {
    (async () => {
      setAccessToken(await cookieService.getRaw(Cookies.USCCA_Access));
    })();
  }, []);

  return accessToken ? (
    <>
      <Title name="SUCCESS!" />

      <p className="form-text">
        We have created your new USCCA account. Click the button below to access{' '}
        your USCCA Dashboard and preview the exceptional training content available to our Members.
      </p>

      {embedService.isEmbedded ? (
        <AuthButton
          id="myAccountButton"
          color="btn-gold"
          text="Continue"
          onClick={() => {
            embedService.messageParent(Messages.Redirect, {
              action: 'login',
              redirect_url: getRedirectTo()
            });
          }}
        />
      ) : (
        <>
          <form className="secret-form" method="POST" action={getSsoRoute()}>
            <input type="text" name="action" value="login" />
            <input type="text" name="redirectTo" value={getRedirectTo()} />
            <input type="text" name="uscca_access" value={accessToken} />
            <AuthButton id="myAccountButton" color="btn-gold" text="Continue" />
          </form>
          <GetMobileApp />
        </>
      )}
    </>
  ) : (
    <LoadingSpinner />
  );
};

export default AccountCreated;
